import React from "react";
import { Col, FormControl, FormGroup, FormLabel, Row } from "react-bootstrap";
import { useWizard } from "./WizardContext";
import { useGuestContext } from "../../../../contexts/GuestContext";
import LanguageToggle from "../LanguageToggle";
import cuteMonk1 from "../../../../assets/img/baolinPrivate/cute_monk1.png";
import cuteMonk2 from "../../../../assets/img/baolinPrivate/cute_monk2.png";

const Step1 = React.forwardRef((props, ref) => {
  const {
    firstname, setFirstname,
    lastname, setLastname,
    chinesename, setChinesename,
    email, setEmail,
    phone, setPhone,
  } = useWizard();
  const { language } = useGuestContext();
  const [errors, setErrors] = React.useState({});

  const validate = () => {
    const nextErrors = {};
    if (!firstname.trim()) nextErrors.firstname = language === "English" ? "First name is required." : "未填寫英文名";
    if (!lastname.trim()) nextErrors.lastname = language === "English" ? "Last name is required." : "未填寫英文姓";
    if (!phone.trim()) nextErrors.phone = language === "English" ? "A contact phone number is required." : "請填寫聯絡電話";
    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  React.useImperativeHandle(ref, () => ({ isValidated: validate }));

  return (
    <div className="wizard-step" ref={ref}>
      <p className="text-center mb-2 font-weight-bold">
        <img src={cuteMonk1} alt="" width="40" className="mr-3" />
        {language === "English" ? "Registration information" : "請提供報名資料"}
        <img src={cuteMonk2} alt="" width="40" className="ml-3" />
      </p>
      <hr />
      <LanguageToggle />
      <hr />

      <Row>
        <Col md={{ span: 5, offset: 1 }}>
          <FormGroup>
            <FormLabel>{language === "English" ? "First Name" : "英文名"}<span className="text-danger"> *</span></FormLabel>
            <FormControl value={firstname} maxLength={30} onChange={(event) => setFirstname(event.target.value)} />
            {errors.firstname && <small className="text-danger">{errors.firstname}</small>}
          </FormGroup>
        </Col>
        <Col md={5}>
          <FormGroup>
            <FormLabel>{language === "English" ? "Last Name" : "英文姓"}<span className="text-danger"> *</span></FormLabel>
            <FormControl value={lastname} maxLength={30} onChange={(event) => setLastname(event.target.value)} />
            {errors.lastname && <small className="text-danger">{errors.lastname}</small>}
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={{ span: 5, offset: 1 }}>
          <FormGroup>
            <FormLabel>{language === "English" ? "Chinese Name" : "中文姓名"}</FormLabel>
            <FormControl value={chinesename} maxLength={30} onChange={(event) => setChinesename(event.target.value)} />
          </FormGroup>
        </Col>
        <Col md={5}>
          <FormGroup>
            <FormLabel>{language === "English" ? "Phone Number" : "電話號碼"}<span className="text-danger"> *</span></FormLabel>
            <FormControl type="tel" value={phone} maxLength={30} onChange={(event) => setPhone(event.target.value)} />
            {errors.phone && <small className="text-danger">{errors.phone}</small>}
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={{ span: 5, offset: 1 }}>
          <FormGroup>
            <FormLabel>{language === "English" ? "Email (optional)" : "電子郵件（選填）"}</FormLabel>
            <FormControl type="email" value={email} maxLength={50} onChange={(event) => setEmail(event.target.value)} />
          </FormGroup>
        </Col>
      </Row>

    </div>
  );
});

export default Step1;
